import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"
import { cn } from "../../lib/utils"

const Tabs = TabsPrimitive.Root

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "dsw-inline-flex dsw-h-9 dsw-items-center dsw-justify-center dsw-rounded-lg dsw-bg-muted dsw-p-1 dsw-text-muted-foreground",
      className
    )}
    {...props}
  />
))
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "dsw-inline-flex dsw-items-center dsw-justify-center dsw-whitespace-nowrap dsw-rounded-md dsw-px-3 dsw-py-1 dsw-text-sm dsw-font-medium dsw-ring-offset-background dsw-transition-all dsw-focus-visible:dsw-outline-none dsw-focus-visible:dsw-ring-2 dsw-focus-visible:dsw-ring-ring dsw-focus-visible:dsw-ring-offset-2 dsw-disabled:dsw-pointer-events-none dsw-disabled:dsw-opacity-50 dsw-data-[state=active]:dsw-bg-background dsw-data-[state=active]:dsw-text-foreground dsw-data-[state=active]:dsw-shadow",
      className
    )}
    {...props}
  />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "dsw-mt-2 dsw-ring-offset-background dsw-focus-visible:dsw-outline-none dsw-focus-visible:dsw-ring-2 dsw-focus-visible:dsw-ring-ring dsw-focus-visible:dsw-ring-offset-2",
      className
    )}
    {...props}
  />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent } 